import axios from 'axios';
const httpClient = axios.create({
	baseURL: '/apps/paba'
});

export default {
	initCaptcha() {
		return httpClient.get('/captcha');
	},
	login(params) {
		return httpClient.post('/login', params);
	},
	sms(params) {
		return httpClient.post('/sms', params);
	},
	changePassword(params) {
		return httpClient.post('/changePass', params);
	},
	loginStatus() {
		return httpClient.get('/loginStatus');
	},
	logout() {
		return httpClient.post('/logout');
	},
	signatures() {
		return httpClient.get('/signatures');
	}
};
